// config.ts
import { config as devConfig } from './config.dev';
import { config as stageConfig } from './config.stage';
import { config as prodConfig } from './config.prod';

let env = 'prod'
if (window.location.host.indexOf('dev') > -1) {
  env = 'dev'
}
if (window.location.host.indexOf('stg') > -1 || window.location.host.indexOf('stage') > -1) {
  env = 'stage'
}
console.log('env===>', env);
let selectedConfig;
switch (env) {
  case 'dev':
    selectedConfig = devConfig;
    break;
  case 'stage':
    selectedConfig = stageConfig;
    break;
  case 'prod':
    selectedConfig = prodConfig;
    break;
  default:
    throw new Error(`Unsupported environment: ${env}`);
}

export const config = selectedConfig;